/**
 * NOTCH: Product catalog by Notch — client-side search + collection filter
 */
(function () {
  if (customElements.get('product-catalog-notch')) return;

  function normalize(str) {
    return (str || '').toLowerCase().trim();
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }

  class ProductCatalogNotch extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this._searchInput = this.querySelector('[data-catalog-search]');
      this._grid = this.querySelector('[data-catalog-grid]');
      this._emptyState = this.querySelector('[data-catalog-empty]');
      this._resultCount = this.querySelector('[data-catalog-result-count]');
      this._filterRoot = this.querySelector('[data-catalog-filters]');

      this._products = Array.prototype.slice.call(this.querySelectorAll('[data-catalog-product]'));

      this._onInput = debounce(this._applyFilters.bind(this), 200);
      this._onChange = this._onChange.bind(this);
      this._onClick = this._onClick.bind(this);

      if (this._searchInput) {
        this._searchInput.addEventListener('input', this._onInput);
      }
      this.addEventListener('change', this._onChange);
      this.addEventListener('click', this._onClick);

      this._initFromUrl();
      this._applyFilters();
    }

    disconnectedCallback() {
      if (!this._initialized) return;
      if (this._searchInput) {
        this._searchInput.removeEventListener('input', this._onInput);
      }
      this.removeEventListener('change', this._onChange);
      this.removeEventListener('click', this._onClick);
      this._initialized = false;
    }

    _onChange(event) {
      if (event.target.matches('[data-collection-handle]')) {
        this._syncUrlFromCheckboxes();
        this._applyFilters();
      }
    }

    _onClick(event) {
      var toggle = event.target.closest('.catalog-notch-filter__toggle');
      if (!toggle || !this.contains(toggle)) return;

      event.preventDefault();
      var item = toggle.closest('.catalog-notch-filter__item--has-children');
      if (!item) return;

      var expanded = toggle.getAttribute('aria-expanded') !== 'false';
      var nextExpanded = !expanded;
      toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      item.classList.toggle('catalog-notch-filter__item--collapsed', !nextExpanded);
    }

    _getCheckedHandles() {
      if (!this._filterRoot) return [];
      return Array.prototype.slice
        .call(this._filterRoot.querySelectorAll('[data-collection-handle]:checked'))
        .map(function (input) {
          return input.getAttribute('data-collection-handle');
        });
    }

    _getSearchTerm() {
      return normalize(this._searchInput ? this._searchInput.value : '');
    }

    _productMatchesCollections(handlesAttr, checkedHandles) {
      if (!checkedHandles.length) return true;
      if (!handlesAttr) return false;

      var productHandles = handlesAttr.split(',');
      return checkedHandles.some(function (handle) {
        return productHandles.indexOf(handle) !== -1;
      });
    }

    _applyFilters() {
      var searchTerm = this._getSearchTerm();
      var checkedHandles = this._getCheckedHandles();
      var visibleCount = 0;

      this._products.forEach(function (item) {
        var title = normalize(item.getAttribute('data-product-title'));
        var handles = item.getAttribute('data-collection-handles') || '';
        var matchesSearch = !searchTerm || title.indexOf(searchTerm) !== -1;
        var matchesCollections = this._productMatchesCollections(handles, checkedHandles);
        var visible = matchesSearch && matchesCollections;

        item.hidden = !visible;
        item.classList.toggle('catalog-notch__grid-item--hidden', !visible);
        if (visible) visibleCount += 1;
      }, this);

      if (this._grid) {
        this._grid.hidden = visibleCount === 0;
      }
      if (this._emptyState) {
        this._emptyState.hidden = visibleCount !== 0;
      }
      if (this._resultCount) {
        if (searchTerm || checkedHandles.length) {
          this._resultCount.textContent = 'Showing ' + visibleCount + ' product' + (visibleCount === 1 ? '' : 's');
          this._resultCount.hidden = false;
        } else {
          this._resultCount.hidden = true;
        }
      }
    }

    _findCheckboxByParam(value) {
      if (!this._filterRoot || !value) return null;

      var normalized = normalize(value);
      var handleized = normalized.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      var checkboxes = this._filterRoot.querySelectorAll('[data-collection-handle]');
      var match = null;

      Array.prototype.forEach.call(checkboxes, function (input) {
        if (match) return;
        var handle = normalize(input.getAttribute('data-collection-handle'));
        var title = normalize(input.getAttribute('data-collection-title'));
        var titleHandle = title.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        var paramAlias = normalize(input.getAttribute('data-collection-param'));
        if (
          handle === normalized ||
          handle === handleized ||
          title === normalized ||
          titleHandle === handleized ||
          paramAlias === normalized ||
          paramAlias === handleized
        ) {
          match = input;
        }
      });

      return match;
    }

    _expandAncestors(element) {
      var parent = element.closest('.catalog-notch-filter__children');
      while (parent) {
        var item = parent.closest('.catalog-notch-filter__item--has-children');
        if (item) {
          item.classList.remove('catalog-notch-filter__item--collapsed');
          var toggle = item.querySelector('.catalog-notch-filter__toggle');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        }
        parent = item ? item.parentElement.closest('.catalog-notch-filter__children') : null;
      }
    }

    _initFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var collectionParam = params.get('collection');
      if (!collectionParam) return;

      var checkbox = this._findCheckboxByParam(collectionParam);
      if (!checkbox) return;

      checkbox.checked = true;
      this._expandAncestors(checkbox);
    }

    _syncUrlFromCheckboxes() {
      var checked = this._getCheckedHandles();
      var url = new URL(window.location.href);

      if (checked.length === 1) {
        url.searchParams.set('collection', checked[0]);
      } else {
        url.searchParams.delete('collection');
      }

      window.history.replaceState({}, '', url.toString());
    }
  }

  customElements.define('product-catalog-notch', ProductCatalogNotch);
})();
